import React from 'react';
import { Icon } from 'antd';

import Form from './Form';

export const UserEditRender = ({ user }) => (
  user
    ? <Form user={user} />
    : (
      <p>
        <Icon
          type="loading"
          theme="outlined"
          spin
        />
      </p>
    )
);

export default UserEditRender;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UserEdit/render.js